import { Link } from '@remix-run/react';
import { styled } from 'styled-components';

const StyledLink = styled(Link)`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border: 1px solid ${({ theme }) => theme.borderPrimary};
  border-radius: 6px;
  color: inherit;
`;

const Logo = styled.img`
  width: 17px;
  height: auto;
  margin-right: 8px;
  object-fit: contain;
`;

const ButtonText = styled.span`
  display: flex;
  align-items: center;
`;

interface AuthLoginButtonProps {
  to: string;
  logoSrc: string;
  altText: string;
  buttonText: string;
}

export default function AuthLoginButton({ to, logoSrc, altText, buttonText }: AuthLoginButtonProps) {
  return (
    <StyledLink to={to}>
      <Logo src={logoSrc} alt={altText} />
      <ButtonText>{buttonText}</ButtonText>
    </StyledLink>
  );
}
